import React from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL } from '@plone/volto/helpers';

const resolveLink = (val) => {
  if (!val) return '';
  if (typeof val === 'string') return val;
  if (Array.isArray(val)) return resolveLink(val[0]);
  if (val['@id']) return flattenToAppURL(val['@id']);
  if (val.url) return val.url;
  return '';
};

const isExternalHref = (href = '') =>
  /^https?:\/\//i.test(href) ||
  href.startsWith('mailto:') ||
  href.startsWith('tel:');

const WelcomeView = ({ data = {}, isEditMode = false }) => {
  const headline = data.headline || '';
  const text = data.text || '';
  const footnoteTitle = data.footnote_title || '';
  const links = Array.isArray(data.links) ? data.links : [];

  return (
    <section className="block fcmh-welcome" aria-labelledby="welcome-headline">
      {headline ? (
        <p id="welcome-headline" className="fcmh-welcome__eyebrow">
          {headline}
        </p>
      ) : null}

      {text ? <div className="fcmh-welcome__intro">{text}</div> : null}

      {(footnoteTitle || links.length > 0) && (
        <div className="fcmh-welcome__footnote">
          {footnoteTitle ? (
            <div className="fcmh-welcome__footnote-title">{footnoteTitle}</div>
          ) : null}

          {links.length > 0 && (
            <nav className="fcmh-welcome__links" aria-label="Fußnoten-Links">
              {links.map((l, i) => {
                const href = resolveLink(l?.href);
                const label = l?.label || 'Link';
                const external = isExternalHref(href);

                return (
                  <React.Fragment key={`${label}-${i}`}>
                    <UniversalLink
                      href={href || '#'}
                      className="fcmh-welcome__link"
                      target={external ? '_blank' : undefined}
                      rel={external ? 'noopener noreferrer' : undefined}
                      disabled={isEditMode}
                    >
                      {label}
                    </UniversalLink>
                    {i < links.length - 1 ? (
                      <span className="fcmh-welcome__sep" aria-hidden="true">
                        |
                      </span>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </nav>
          )}
        </div>
      )}
    </section>
  );
};

export default WelcomeView;
